import { render, staticRenderFns } from "./VersionContract.vue?vue&type=template&id=289c9a47&scoped=true"
import script from "./VersionContract.vue?vue&type=script&lang=js"
export * from "./VersionContract.vue?vue&type=script&lang=js"
import style0 from "./VersionContract.vue?vue&type=style&index=0&id=289c9a47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c9a47",
  null
  
)

export default component.exports